import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

const url = createUrl('elibro');

export class Books extends Api {
    constructor(http, config = {}) {
        super(http, url, 'books', config);
    }
}